<template lang="pug">
  .simple-select-form__list(
  @click="onClickList($event)"
  )
    ul
      li(
      v-for="item in dataList"
      :class="{ 'li-selected': item.value !== undefined ? item.value === defaultValue.value : item === defaultValue }"
      @click="onSelectItem(item)"
      ) {{item.text ? item.text : item}}
</template>

<script>
export default {
  name: "custom-select-list",
  components: {},
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    showList: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: [String, Object],
      default: "",
    },
  },
  data() {
    return {
      selected: true,
    };
  },
  methods: {
    onSelectItem(li) {
      this.$emit("onSelectItem", li);
      this.$emit("close");
    },
    onClickList(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.$emit("close");
    },
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  },
};
</script>
